export enum TemplateDocumentTypeEnum {
  NotSet = 0,
  EnrollmentAgreement = 1,
  W9ACH = 2,
  AdminLocationForm = 3,
  Other = 901
}
